export const ICON_SIZE = {
  LARGE: '64px', // 4rem
  STANDARD: '40px',
  MEDIUM: '25px',
  SMALL: '20px',
};
